<template>
  <div class="new-home2-page">
    <div class="new-home-top-banner">
      <game-header :bannerCode="bannerCode" :isShowBanner="true"  style="margin-top:0px;overflow: hidden;"></game-header>
    </div>
    <div class="home_menu">
      <a href="javascript:" @click="goAnchor('#featured')">{{$t('newHome.featured')}}</a>
      <a href="javascript:" @click="goAnchor('#popular')">{{$t('newHome.topgame')}}</a>                     
      <a href="javascript:" @click="goAnchor('#liveGames')">{{$t('newHome.live')}}</a>                     
      <a href="javascript:" @click="goAnchor('#slot')">{{$t('newHome.slot')}}</a>                     
      <a href="javascript:" @click="goAnchor('#sport')">{{$t('newHome.sport')}}</a>                     
      <a href="javascript:" @click="goAnchor('#affiliate')">{{$t('newHome.affiliate')}}</a>                     
      <a href="javascript:" @click="goAnchor('#providers')">{{$t('newHome.providers')}}</a>                     
  </div>
  <div id="featured" class="featured-area">
        <div class="title-container">
          <h4>{{$t('newHome.featured')}}</h4>
          <p class="btn-more" @click="handleSeeAll('/games')">{{ $t('newHome.SeeAll') }} </p>
        </div>
        <swiper ref="mySwiper" class="featured-swiper"
          :options="swiperOption2">
          <swiper-slide v-for="(item,index) in featuredList" class="swiper-slide-item" :key="index" @click.native="indexBannerGoHref(item.imgClickLink)">
            <img style="cursor: pointer" :src="item.imgLink" alt width="100%">
          </swiper-slide>

      </swiper>
          <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> </div>
    <!-- popular games-->
    <div class="popular-games commongames" id="popular">
        <div class="title-container">
          <h4>{{$t('newHome.topgame')}}</h4>
          <p class="btn-more" @click="handleSeeAll('/hotGame')">{{ $t('newHome.SeeAll') }} </p>
        </div>
        <ul>
            <li v-for="(item,index) in hotgamelist" :key="index">
              <div class="sport-img"> 
                <img :src=" staticDomain + item.pcImg" alt width="100%" height="100%" />
              </div>
              <div class="hover-showe">
                  <div class="sport-Introduction">
                  <p class="p_"> {{item.fullName}}</p>
                  <p class="playNow" @click="handeleGoGame(item)">{{ $t('game.playNow') }}</p>
                </div>
              </div>
            </li>
        </ul>
      <div class="center-banner-detail" v-if="indexCenterBannerList.length>0">
        <swiper ref="mySwiper3" class="center-swiper-wrap"
          :options="swiperOption3">
          <swiper-slide v-for="(item,index) in indexCenterBannerList" class="swiper-slide-item" :key="index">
              <img style="cursor: pointer" :src="item.imgLink" alt width="100%"  @click="centerGoGame(item)">
          </swiper-slide>
          <div class="swiper-pagination center-banner-pagination" slot="pagination"></div>
        </swiper>
      </div>        
    </div>
    <!-- live gamse-->
    <div class="live-games commongames" id="liveGames">
      <div class="title-container">
        <h4>{{$t('newHome.live')}}</h4>
        <p class="btn-more" @click="handleSeeAll('/games')">{{ $t('newHome.SeeAll') }} </p>

        <!-- <p class="btn-more" @click="handleSeeAll('/live')">{{ $t('newHome.SeeAll') }} ({{allGameList.liveList.length}})</p> -->
      </div>
      <ul>
          <li v-for="(item,index) in allGameList.liveList.slice(0,4)" :key="index">
            <div class="sport-img"  @click="handeleGoGame(item)">
              <img :src="staticDomain + item.pcLogoImg" alt width="100%"  />
            </div>
            <!-- <div class="hover-showe">
              <div class="sport-Introduction">
                <p class="p_"> {{item.fullName}}</p>
                <p class="playNow" @click="handeleGoGame(item)">{{ $t('game.playNow') }}</p>
              </div>
            </div> -->
          </li>
      </ul>
    </div>
    <!-- slots gamse-->
    <div class="slot-games commongames" id="slot">
      <div class="title-container">
        <h4>{{$t('newHome.slot')}}</h4>
        <p class="btn-more" @click="handleSeeAll('/slots')">{{ $t('newHome.SeeAll') }}</p>
      </div>
      <ul>
        <li v-for="(item,index) in allGameList.slotsList.slice(0,4)" :key="index">
          <div class="sport-img">
            <img :src="staticDomain + item.pcLogoPic" alt width="100%" height="100%" />
          </div>
          <div class="hover-showe">
            <div class="sport-Introduction">
              <p class="p_"> {{item.fullName}}</p>
              <p class="playNow" @click="handeleGoGame(item)">{{ $t('game.playNow') }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
   <!-- sport gamse-->
    <div class="sport-games commongames" id="sport">
      <div class="title-container">
          <h4>{{$t('newHome.sport')}}</h4>
          <p class="btn-more" @click="handleSeeAll('/sports')">{{ $t('newHome.SeeAll') }} </p>
      </div>
      <ul> 
          <li v-for="(item,index) in allGameList.sportList.slice(0,4)" :key="index">
            <div class="sport-img" @click="handeleGoGame(item)">
              <img :src="staticDomain + item.pcLogoPic" alt width="100%" />
              </div>
            <!-- <div class="hover-showe">
              <div class="sport-Introduction">
                <p class="p_"> {{item.fullName}}</p>
                  <p class="playNow" @click="handeleGoGame(item)">{{ $t('game.playNow') }}</p>
              </div>
            </div> -->
          </li>
      </ul>
    </div>
  <div id="affiliate" class="affiliate-area">
    <div class="affiliate-title">{{$t('newHome.affiliateName')}}</div>
    <ul>
      <li v-for="(item,index) in affiliateList" class="swiper-slide-item" :key="index">
        <img style="cursor: pointer" :src="item.imgLink" alt width="100%">
      </li>
    </ul>
    <div class="affiliate_link">
      <div class="affiliate_intro">
        {{$t('newHome.affiliateTitle')}}<br>
        {{$t('newHome.affiliateIntro')}}
      </div>
      <router-link to="/agency" class="agecy-btn">
          <span>{{$t('newHome.joinNow')}}</span>
      </router-link>
    </div>
  </div>  
  <div id="providers" class="providers-area">

  </div>

  </div>
</template>

<script>
import GameHeader from '../game-header/game-header'
import { PENDANT_CRICKET_BANNER,Featured_BANNER ,IC_Index_Center_BANNER,affiliate_BANNER} from '../../assets/js/bannerCode'
import myMarquee from '../common/marquee/marquee-news';
import { mapState , mapMutations} from 'vuex'
import { common,commonApi } from '@/common/index'
import $Cookies from 'js-cookie';
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
   components:{ GameHeader , myMarquee,swiper, swiperSlide},
    data(){
        return{
            bannerCode:PENDANT_CRICKET_BANNER,
            GList:[],
            featuredList: [],
            featuredCode: Featured_BANNER,
            affiliateCode: affiliate_BANNER,
            centerBannerCode: IC_Index_Center_BANNER,
            indexCenterBannerList:[],
            affiliateList:[],
            swiperOption2: {
              slidesPerView :4,
              spaceBetween : 30,
              loop: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }
            },  
            swiperOption3: {
              loop: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet(index, className) {
                  return `<span class="${className} swiper-pagination-bullet-custom"></span>`
                }
              },
              autoplay: {
                delay: 4000,
                autoplayDisableOnInteraction: false
              },
            },  
          hotgamelist:[],
          mySlotList:[],
          allGameList:{
            liveList: [],
            slotsList:[],
            sportList:[],
            lotteryList:[],
          },
          query:{
            pageNo:1,
            pageSize:100
          },
          params:{
            UUID:null,
            targetId:null,
            type:null
          }                    
        }
    },
  computed: {
    ...mapState({
      UUID: state => state.UUID,
      isLogin: state => state.isLogin,
      staticDomain: state => state.linkList.staticDomain,
      frontType: state => state.frontType,
    }),
    mySwiper(){
      return this.$refs.mySwiper.swiper;
    }
  },
    watch:{
      isLogin:{
         handler(newV,oldV) {
          this.homeInit()
        }
      }
    },
    created(){
     // this.getAllPlatform()
      this.homeInit();
    },
    methods: {
      ...mapMutations([ "setshowloginfloat2"]),
      // handleGoInside({ type }){
      //   this.$router.push({ path: '/games', query: { type:type } })
      // },
    // 标签滚动
    goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
          behavior: "smooth",  // 平滑过渡
          block:    "start"  // 上边框与视窗顶部平齐。默认值
      });
    },
    centerGoGame(item){
      window.open(item.imgClickLink);
    },
    handleSeeAll(path){
      this.$router.push({path:path});
    },
    homeInit(){
      commonApi.GAME.newHeatGamePlatform({}).then((data) => {
        this.hotgamelist = data.slice(0,4)
      })
      this.getAllPlatform(); 
    },
    handeleGoGame(item){
      if(this.isLogin){
        if(item.hasOwnProperty('popularType') && item.popularType === '1'){ // 热门游戏 1 游戏
          common.jinsha_GoGame(item,this.isLogin,this.UUID)
        }else if(item.gameType == '1' && item.popularType === '0' && item.popularType){ // 0 游戏
          this.$router.push({ path: '/slots', query: { platformCode: item.platformCode } })
        }else if(item.gameType == '1' && !item.gameId){ // 非热门中电子  gameId没有是平台
          this.$router.push({ path: '/slots', query: { platformCode: item.platformCode } })
        }else{   // 其他所有近游戏
          common.jinsha_GoGame(item,this.isLogin,this.UUID)
        }
      }else{
        this.$notify({
          title:this.$t('notify.warning'),
          message:this.$t('newHome.login'),
          type: "warning",
        });
        this.setshowloginfloat2(true);
      }
    },
    getAllPlatform() {   // InGamePlatformGroup
      this.loading = true;
      this.$api.post(this.$urls.SLOT.InGamePlatformGroup, {}, resp => {
        if(resp.data.code == 200){
          this.loading = false;
          const [slotsList,liveList,sportList,lotteryList] = Object.values(resp.data.data)
          this.allGameList = {slotsList,liveList,sportList,lotteryList}
        }else{
          this.loading = false;
          this.allGameList = {}
        }
      })
    },
    getfeaturedList() {
      commonApi.HOMEBEFORE.fetchImg(this.featuredCode)
        .then((list) => {
          this.banner = list[0].imgLink;
          this.bannerLink = list[0].imgClickLink;
          // 首页轮播
          this.featuredList = list;
          this.initIndexBannerLinkList()
        })
        .catch(err => {})
    },
    initIndexBannerLinkList() {
      if(this.featuredList.length>0){
        let arr = [];
        this.featuredList.forEach((item)=>{
          arr.push(item.imgClickLink)
        });
        // 将第一个链接添加到最后，对应swiper复制到最后一个
        this.indexBannerLinkList = [...arr,arr[0]];
      }
    },
    indexBannerGoHref(e) {

      // let index = this.mySwiper.activeIndex;
      // let link = this.indexBannerLinkList[index];

      console.log(e)
      this.goBannerHref(e)
    },
    goBannerHref(url) {
      if(!url) return;
      // 去掉链接里面的/launchGame?
      let rightUrl = url.replace('/launchGame?','');
      if(this.isLogin){
        let lang = $Cookies.get('lang');
        let href =  `/api/game/forward?UUID=${this.UUID}&linkType=0&lang=${lang}&` + rightUrl;
       window.open(href)
      }else{
        this.$notify({
          title:this.$t('notify.warning'),
          message:this.$t('newHome.login'),
          type: "warning",
        });
        this.setshowloginfloat2(true);
      }

      // let path = common.goHref(url);
      // if(path) {
      //   this.$router.push({path})
      // }
    },
    getCenterBannerList() {
      commonApi.HOMEBEFORE.fetchImg(this.centerBannerCode)
        .then((list) => {
          this.indexCenterBannerList = list;
        })
        .catch(err => {})
    },
    getAffilatileList() {
      commonApi.HOMEBEFORE.fetchImg(this.affiliateCode)
        .then((list) => {
          // 代理图片
          this.affiliateList = list;
        })
        .catch(err => {})
    },
  },

  mounted() {
    this.getfeaturedList();
    this.getCenterBannerList();
    this.getAffilatileList();
  }

}
</script>

<style lang="scss" scoped>
@import './index.scss';
.new-home2-page{
    width:1160px;
    margin:0 auto;
    padding:20px 0;
    z-index:1;
    position: relative;
    .home_menu{
      a{ 
        color: #000;
        font-weight: bold;
        padding-bottom: 5px;
        margin-right: 35px;
      }
      a.active,a:hover{
        border-bottom: 1px solid #e8ab06;
      }
    }
    .title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000;
        font-size: 18px;        
        h4{
          color: #000;
          margin:20px 0;
        }
        .btn-more {
            color: black;
            font-weight: 600;
            background-color: #f5f5f5;
            padding: 6px 20px;
            border-radius: 5px;
            font-family: Roboto;
            box-shadow: none;
            border: 0;
            display: block;
        }
         .btn-more:hover{background: #e8ab06;}
    }    
    .featured-area{
        margin-top: 20px;
        height: 250px;
        position: relative;
      .featured-swiper{
        width: 1160px;
        height: 180px;
        margin: 0 auto;
        position: relative;
      }
      /deep/ .swiper-button-prev, .swiper-button-next{
          width: 70px;
          height: 64px;
          transform: translateY(15px);
          &.swiper-button-prev{ 
            left:-20px; 
            background: url(./img/arrow_left.png) no-repeat;
            }
          &.swiper-button-next{ 
            right:-20px;
            background: url(./img/arrow_right.png) no-repeat;
           }
      }
    }
    .commongames{
      position: relative;
      margin-bottom:35px;
      margin-top:29px;
      ul{
        display:flex;
        justify-content: space-between;
        margin-top:10px;
        li{
          position: relative;
          cursor: pointer;
          overflow: hidden;
          margin-right:10px;
          transition: all 300ms;
          border-radius: 8px;
          &:hover{
           box-shadow: 0 0 5px #e8ab06;
          }
          .sport-img{
            width:100%;
            height:100%;
            overflow: hidden;
          }
          .hover-showe{
            width:100%;
            height:132px;
            background: #f9f9f8;
            .sport-Introduction{
              padding: 10px 0 0 15px;
              height:100%;
              font-family: Roboto-Bold;
              font-size: 22px;
              color: #000;
              .p_ {word-wrap:break-word;margin-bottom: 15px;} 
              .playNow{
                width: 140px;
                height: 56px;
                line-height: 56px;
                background-color: #e8ab06;
                border-radius: 12px;
                font-family: Roboto-Black;
                font-size: 18px;
                text-align: center;
                 color: #fff;
              }
              .favorite{
                width:30px;
                height:30px;
                position: absolute;
                top: 8px;
                right: 10px;
                z-index: 11;
                cursor: pointer;
                &.homeCollected{
                  i{  background-image:url('../game-item/slots/img/heart_h.png');}
                }
                i{
                  width:100%;
                  height:100%; 
                  background-image:url('../game-item/slots/img/heart_n.png');
                  display:inline-block;
                  background-size: 69% 65%;
                  background-repeat: no-repeat;
                  background-position: center;
                }
              }
            }
          }
        }
      }
    }
    .popular-games,.slot-games{
      // margin-top:29px;
      ul{
        position: relative;
        height: 393px;
        li{
          position: relative;
          width:262px;
          height: 100%;
          margin-right: 0;
          .sport-img{
            height: 266px;
          }
        }
      }
    }
    .live-games,.sport-games{
      ul{
        position: relative;
       // height: 564px;
        li{
          position: relative;
          width:262px;
          height: 100%;
          margin-right: 0;
          .sport-img{
            // height: auto;
          }
          .hover-showe{
            position: absolute;
            bottom: 40px;
            left: 0;
            background: none;
            .sport-Introduction{
              color: #fff;
              .p_{ text-shadow: 0 0 5px #000; font-size: 28px;}
            }
          }
        }
      }
    }
    .center-banner-detail{
      margin: 30px auto 0;
      .center-banner-pagination{
        right: 50px;
        bottom: 50px;
        .swiper-pagination-bullet{
          width: 15px;
          height: 15px;
          background: #d9d9d9;
        }
        /deep/.swiper-pagination-bullet-active{
          background: #e8ab06 !important;
        }
      }
    }
    .affiliate-area{
      margin-top: 60px;
      .affiliate-title{
        color: #e8ab06;
        text-align: center;
        font-size: 40px;
        font-weight: bolder;
        margin-bottom: 40px;
      }
      ul{
        display: flex;
        justify-content: space-between;
        li{width: 30%;}
      }
      .affiliate_link{
        margin-top: 100px;
        display: flex;
        align-content: center;
        justify-content: flex-start;
        .affiliate_intro{
          width: 700px;
          color: #000;
          font-size: 30px;
          line-height: 48px;
        }
        .agecy-btn{
          margin: 30px 0 0 50px;
          background: #e8ab06;
          padding: 0 40px;
          height: 100px;
          line-height: 100px;
          color: #fff;
          font-size: 30px;
          border-radius: 8px;          
        }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/build901/components/new-home/new-home2.vue